import { render, staticRenderFns } from "./ColorPickerWrap.vue?vue&type=template&id=6e634fd4&scoped=true"
import script from "./ColorPickerWrap.vue?vue&type=script&lang=js"
export * from "./ColorPickerWrap.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerWrap.vue?vue&type=style&index=0&id=6e634fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e634fd4",
  null
  
)

export default component.exports